import AbandonedCarts from 'components/abandonedCarts';
const AbandonedCartsPage = () => {
  return <AbandonedCarts />;
};

export default AbandonedCartsPage;
